import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { ABBREV_TO_STATE, STATE_ABBREV, US_STATES } from '../constants';

interface StateSelectProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
}

const StateSelect: React.FC<StateSelectProps> = ({
  id = 'state-select',
  value,
  onChange,
  placeholder = 'Select state',
  ariaLabel = 'State select',
  className = 'text-sm w-full',
}) => {
  // Display the full state name for the selected value (which is an abbreviation)
  const displayValue = value ? ABBREV_TO_STATE[value] || value : undefined;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        id={id}
        tabIndex={0}
        className={className}
        aria-label={ariaLabel}
      >
        <SelectValue placeholder={placeholder}>{displayValue}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {US_STATES.map((stateName) => {
          const abbrev = STATE_ABBREV[stateName];
          return (
            <SelectItem key={abbrev} value={abbrev} className="text-sm">
              {stateName}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};

export default StateSelect;
